import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef, useCallback } from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import AntMainFooter from '../AntMainFooter';
import useServiceQuotaNotice, { showServiceQuotaResolveGuide } from '../AntMainFooter/useServiceQuotaNotice';
import { useNavigate } from 'react-router-dom';

import { AntGlobal, AntSession } from '../../utils/AntContext';

import './index.scss';

export default function (props) {
    const navigate = useNavigate();
    const appGlobal = AntGlobal();
    const session = AntSession();
    const { appInfo, appAssets } = appGlobal;

    const refScrollView = useRef();
    // Vượt hạn mức gói dịch vụ: POS không có màn gói dịch vụ nên admin bấm để xem hướng dẫn xử lý.
    const quotaNotice = useServiceQuotaNotice(session, { onOpenBilling: showServiceQuotaResolveGuide });

    return (
        <div className={'ant-pos-layout'}>
            <ScrollView ref={refScrollView} className={'ant-pos-scrollview'} showScrollbar="never" useNative={false}>
                <div className={'ant-pos-scrollview-content'}>{React.Children.map(props.children, (item) => item)}</div>
            </ScrollView>

            {session && quotaNotice && (
                <AntMainFooter type={quotaNotice.type} onClick={quotaNotice.onClick}>
                    {`© 2026 ante.vn | ${session.business_short_code} : ${quotaNotice.text}`}
                </AntMainFooter>
            )}
        </div>
    );
}
